<template>
  <el-row>
    <el-col :span="12">
      <div class="content-item flex">
        <div class="content-item-label">症状标签</div>
        <div class="symptom-tab-list flex">
          <div class="top-wrap">
            <span class="symptom-tab symptom-tab-add" @click="opensymptomDialog"
              >添加症状</span
            >
            <p class="symptom-tips blue have" @click="symptomTips = true">
              为什么要打症状标签？
            </p>
          </div>

          <div class="symptom-tab-wrap">
            <span
              class="symptom-tab"
              v-for="(item, index) in symptomLabels"
              :key="index"
            >
              {{ item.symptomName }}
              <img src="~_img/off.png" alt="del" @click="delsymptom(index)" />
            </span>
          </div>
        </div>

        <el-dialog
          class="tips-dialog"
          title="为什么要打症状标签"
          :show-close="false"
          :visible.sync="symptomTips"
          width="722px"
          center
        >
          <div>
            <p class="before-content-color title">
              <span class="before-icon"></span> 症状标签说明
            </p>
            <p class="dialog-contents">
              给文章打上相关的症状，可以帮您更好的展示文章
            </p>
          </div>
          <div slot="footer" class="dialog-footer btns">
            <el-button
              type="primary"
              @click="symptomTips = false"
              class="dialog-but"
              >我知道了</el-button
            >
          </div>
        </el-dialog>
        <!-- <p>给文章打上相关的症状，可以帮您更好的展示文章</p> -->
        <modal
          :isShow.sync="dialogSymptomVisible"
          :title="dialogTitles"
          :btnText="btnText"
          :isShowBtn="isShowBtn"
          :width="dialogWidth"
          @clickHandler="clickHandler"
        >
          <div class="search-dialog-wrap">
            <el-input
              placeholder="请输入内容"
              v-model="searchSymptomName"
              class="input-with-select"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="querysymptoms"
                class="search-but"
                >搜索</el-button
              >
            </el-input>
            <div class="search-symptom-body">
              <div class="search-data">
                <el-checkbox-group
                  v-model="searchSymptomChecked"
                  v-if="searchSymptomList.length && !isShowSearchNoData"
                  @change="searchsymptomChange"
                >
                  <el-checkbox
                    :label="item.symptomId"
                    v-for="(item, index) in searchSymptomList"
                    :key="index"
                    >{{ item.symptomName }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div
                class="noData flex flex-direction-column justify-content-center align-items-center"
                v-if="isShowSearchNoData"
              >
                <img src="~_img/search-noData.png" alt="没有数据" />
                <p class="errorInfo">很抱歉，暂未收录相关症状</p>
              </div>
            </div>
          </div>
        </modal>
      </div>
    </el-col>

    <el-col :span="12">
      <div class="large-tab-wrap">
        <!-- <div>{{largeModelLabels}}</div> -->
        <span
          :class="item.isSelected ? 'large-tab selected' : 'large-tab'"
          v-for="(item, index) in largeModelLabels"
          :key="index"
          @click="clickLargeModel(item)"
        >
          <i :class="item.isSelected ? `el-icon-check` : `el-icon-plus`"></i>
          {{ item.labelValue }}
        </span>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { request } from "@/utils/axios";
import modal from "@/components/modal";
export default {
  name: "symptomLabel",
  props: ["csdata", "functionIds", "largeModelLabelBizDTOS"],
  data() {
    return {
      symptomTips: false,
      dialogSymptomVisible: false, //添加症状弹窗
      isShowSearchNoData: false,
      searchSymptomName: "",
      searchSymptomList: [],
      searchSymptomListHistory: [],
      searchSymptomChecked: [],
      symptomLabels: [],
      dialogTitles: "搜索症状",
      btnText: ["取消", "确认"],
      dialogWidth: "480px",
      isShowBtn: [true, true],
      largeModelLabels: [],
    };
  },
  components: {
    modal,
  },
  watch: {
    largeModelLabelBizDTOS(val) {
      this.largeModelLabels = val;
      if (this.symptomLabels.length > 0) {
        console.log(val, this.symptomLabels, "pppppppp--------->11111111");
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          const findRes = this.symptomLabels.find((sItem) => {
            return sItem.symptomId == lItem.labelId;
          });
          if (findRes) {
            lItem.isSelected = true;
          }
          return lItem;
        });
      }
    },
    csdata(val) {
      console.log("🚀 ~ file: SymptomLabel.vue:84 ~ csdata ~ val:", val);

      this.searchSymptomChecked = [];
      if (val) {
        for (let i = 0; i < val.length; i++) {
          this.searchSymptomChecked.push(val[i].symptomId);
        }
      }
      this.symptomLabels = val;
      val.map((item) => {
        this.searchSymptomListHistory.push(item);
      });
      if (this.largeModelLabels.length > 0) {
        console.log(val, this.largeModelLabelBizDTOS, "pppppppp--------->");
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          const findRes = this.symptomLabels.find((sItem) => {
            return sItem.symptomId == lItem.labelId;
          });
          if (findRes) {
            lItem.isSelected = true;
          }
          return lItem;
        });
      }
    },
  },
  created() {
    // this.symptomLabels=this.data;
  },
  methods: {
    clickHandler(val) {
      if (val == "one") {
        this.dialogSymptomVisible = false;
      }
      if (val == "two") {
        this.addSymptom();
      }
    },
    //打开症状标签弹窗
    opensymptomDialog() {
      this.dialogSymptomVisible = true;
      this.isShowSearchNoData = false;
      this.searchSymptomList = [];
      this.searchSymptomName = "";
    },
    // 获取选中的症状标签
    searchsymptomChange() {
      if (this.searchSymptomChecked && this.searchSymptomChecked.length > 3) {
        this.$message.error("症状标签最多选3个~");
        this.searchSymptomChecked.pop();
      }
    },
    //
    getsearchSymptomListData() {
      let array = this.searchSymptomListHistory.filter((item) => {
        return this.searchSymptomChecked.some((i) => {
          return i == item.symptomId;
        });
      });
      let _map = [];
      return array.filter((item) => {
        if (!_map.includes(item.symptomId)) {
          _map.push(item.symptomId);
          return true;
        } else {
          return false;
        }
      });
    },
    //添加症状
    addSymptom() {
      if (this.searchSymptomChecked.length > 3) {
        return;
      }
      let dataList = this.getsearchSymptomListData();
      console.log(
        "🚀 ~ file: SymptomLabel.vue:151 ~ addSymptom ~ symptomLabels:",
        this.symptomLabels.length,
        dataList.length
      );
      const isAdd = this.symptomLabels.length < dataList.length;
      this.symptomLabels = this.symptomLabels || [];
      this.symptomLabels.splice(0, this.symptomLabels.length, ...dataList);
      this.dialogSymptomVisible = false;
      console.log(
        "🚀 ~ file: SymptomLabel.vue:151 ~ addSymptom ~ symptomLabels:",
        this.symptomLabels,
        dataList
      );
      // 处理 大模型选中
      if (isAdd) {
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          const findRes = this.symptomLabels.find((sItem) => {
            return sItem.symptomId == lItem.labelId;
          });
          if (findRes) {
            lItem.isSelected = true;
          }
          return lItem;
        });
      } else {
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          const findRes = this.symptomLabels.find((sItem) => {
            return sItem.symptomId == lItem.labelId;
          });
          if (!findRes) {
            lItem.isSelected = false;
          }
          return lItem;
        });
      }

      this.$emit("changeSymptomLabels", this.symptomLabels);
    },
    delsymptom(index) {
      this.symptomLabels.splice(index, 1);
      this.searchSymptomChecked.splice(index, 1);
      console.log(
        "🚀 ~ file: SymptomLabel.vue:157 ~ addSymptom ~ symptomLabels:",
        this.symptomLabels
      );
      // 处理 大模型选中
      this.largeModelLabels = this.largeModelLabels.map((lItem) => {
        const findRes = this.symptomLabels.find((sItem) => {
          return sItem.symptomId == lItem.labelId;
        });
        if (!findRes) {
          lItem.isSelected = false;
        }
        return lItem;
      });
      this.$emit("changeSymptomLabels", this.symptomLabels);
    },
    // 搜索症状
    querysymptoms() {
      if (this.searchSymptomName) {
        request(this.functionIds.getSymptom, {
          tenantId: this.$commonJs.getTenantId(),
          symptomName: this.searchSymptomName,
          pageNo: 1,
          pageSize: 20,
        })
          .then((res) => {
            console.log(
              "🚀 ~ file: SymptomLabel.vue:163 ~ querysymptoms ~ res:",
              res
            );
            if (res.data && res.data.length) {
              this.isShowSearchNoData = false;
              this.searchSymptomList = res.data;
              res.data.map((item) => {
                this.searchSymptomListHistory.push(item);
              });
            } else {
              this.isShowSearchNoData = true;
            }
          })
          .catch((err) => {
            this.isShowSearchNoData = true;
          });
      } else {
        this.isShowSearchNoData = true;
      }
    },
    // 选中大模型
    clickLargeModel(item) {
      if (
        this.searchSymptomChecked &&
        this.searchSymptomChecked.length == 3 &&
        item.isSelected == false
      ) {
        this.$message.error("症状标签最多选3个~");
        return;
      }
      this.largeModelLabels = this.largeModelLabels.map((largeItem) => {
        console.log(
          largeItem.labelId,
          item.labelId,
          "点击了----------------》",
          item.labelId == largeItem.labelId
        );
        if (item.labelId == largeItem.labelId) {
          largeItem.isSelected = !largeItem.isSelected;
          console.log("点击了----------------》22222222", item.isSelected);
          // 如果是选中状态
          if (item.isSelected) {
            // 选中
            const rightItem = {
              symptomId: item.labelId,
              symptomName: item.labelValue,
            };
            this.symptomLabels = [...this.symptomLabels, rightItem];
          } else {
            // 取消选中
            this.symptomLabels = this.symptomLabels.filter((fItem) => {
              return fItem.symptomId != item.labelId;
            });
          }
          this.$emit("changeSymptomLabels", this.symptomLabels);
        }
        return largeItem;
      });
    },
    clickOnceApply(applyStatus) {
      if (applyStatus) {
        //  判断现在有多少个
        let addCount = 3 - this.searchSymptomChecked.length;
        // 去重复
        // const sameCount = this.largeModelLabels.filter((largeItem)=> largeItem.isSelected);
        // addCount = addCount + sameCount.length;
        this.largeModelLabels = this.largeModelLabels.map((largeItem) => {
          if (!largeItem.isSelected && addCount > 0) {
            largeItem.isSelected = true;
            addCount--;
            const rightItem = {
              symptomId: largeItem.labelId,
              symptomName: largeItem.labelValue,
            };
            this.symptomLabels = [...this.symptomLabels, rightItem];
          }
          return largeItem;
        });
      } else {
        // 一键取消
        this.largeModelLabels = this.largeModelLabels.map((largeItem) => {
          // 相等 删除
          this.symptomLabels = this.symptomLabels.filter((fItem) => {
            if (largeItem.labelId == fItem.symptomId) {
              largeItem.isSelected = false;
            }
            return fItem.symptomId != largeItem.labelId;
          });

          return largeItem;
        });
      }
      this.$emit("changeSymptomLabels", this.symptomLabels);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/dialog_common.scss";
$color: #266cee;
.input-with-select {
  width: 437px !important;
  padding-bottom: 4px !important;
}
//症状搜索
.search-dialog-wrap {
  min-height: 138px;
  margin: 20px;
  .search-data {
    max-height: 138px;
    overflow: hidden;
    overflow-y: auto;
    margin-top: 20px;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      width: 4px;
      height: 30px;
      background-color: #989ca5;
    }
    .el-checkbox {
      margin-right: 24px;
    }
    .el-checkbox__label {
      color: #262626;
      padding-left: 6px;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background: $color;
      border-color: $color;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #262626;
    }
    .el-checkbox__inner:hover {
      border-color: $color;
    }
  }
  .noData {
    img {
      width: 121px;
      height: 78px;
      border: none;
    }
    p {
      font-size: 12px;
      color: #9a9a9a;
      margin-top: 20px;
    }
  }
}
.have {
  cursor: pointer;
}
.btns {
  padding-bottom: 22px;
  padding-top: 40px;
  line-height: 0px !important;
}
:deep(.content-item) {
  min-width: 100% !important;
}
.dialog-but {
  padding-top: 9px;
}
:deep(.button) {
  line-height: 0px !important;
}
:deep(.el-button .el-button--primary) {
  padding-top: 10px;
}
.search-but {
  padding-top: 8px;
}
.errorInfo {
  width: 145px !important;
  text-align: right;
  margin-right: 10px;
}
.symptom-tips {
  width: 147px !important;
  height: 20px;
  // position: absolute;
  // left: 560px;
  // top: 0;
}
.symptom-tab-add {
  width: 105px !important;
  position: absolute !important;
  left: 0px;
  top: -43px;
}
.symptom-tab-list {
  // position: relative !important;
  flex-direction: column !important;
  .top-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .symptom-tab {
      display: inline-block;
      height: 32px;
      line-height: 32px;
      text-align: center;
      // background: rgba(255, 110, 0, 0.12);
      border-radius: 2px;
      padding: 0 16px;
      margin-right: 28px;
      cursor: pointer;
      position: relative;
      margin-bottom: 10px;

      img {
        position: absolute;
        top: -8px;
        right: -8px;
        width: 15px;
        height: 15px;
        background-size: 15px;
      }
    }
  }
  .symptom-tab-wrap {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  .symptom-tab {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    // background: rgba(255, 110, 0, 0.12);
    border: 1px solid #0058ee;
    border-radius: 2px;
    padding: 0 16px;
    margin-right: 28px;
    // margin-top: 40px !important;
    cursor: pointer;
    // color: #FF6E00;
    color: #0058ee;
    position: relative;
    img {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 15px;
      height: 15px;
      background-size: 15px;
    }
  }
  .symptom-tab-add {
    position: static !important;
    margin-top: 0px !important;
    border: 1px dashed rgba(154, 154, 154, 1);
    background: rgba(255, 255, 255, 1);
    color: rgba(38, 38, 38, 1);
    &::before {
      content: "";
      display: inline-block;
      width: 12px;
      height: 12px;
      background: url("~_img/add.png") no-repeat;
      background-size: 12px;
    }
    &::after {
      display: none;
    }
  }
}

.large-tab-wrap {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;

  .large-tab {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border: 1px solid #ffa400;
    border-radius: 2px;
    padding: 0 16px;
    margin-right: 28px;
    cursor: pointer;
    color: #ffa400;
    margin-bottom: 20px;
    font-size: 14px;
    img {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 15px;
      height: 15px;
      background-size: 15px;
    }
    &.selected {
      border: 1px solid rgba(195, 195, 195, 1);
      color: #ffffff;
      background-color: rgba(195, 195, 195, 1);
    }
  }
}
</style>
